import { BaseModel } from '@core/models/base-model';
import { Field, Model, Name } from '@junte/serialize-ts';

@Model()
export class Entity extends BaseModel {
  @Field()
  @Name('uid')
  public readonly id: string;
}
